export default "__VITE_ASSET__1cd2237c__"